import React from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

// Translations
import translate from '../Translate.js';

// Dependencies
import LimitTextarea from '../Common/LimitTextarea';
import { handleSwitchInputKeys } from '../../helpers/helpers.js';
import FeatureFlag from 'react-launch-darkly/build/components/FeatureFlag';

const EditPermittedItems = observer(class EditPermittedItems extends React.Component {
  componentWillMount() {
    const { exam, customConfiguration, enrollmentConfig } = this.props;

    if(enrollmentConfig) {
      if(this.props.configuration) {
        this.state = {
          configuration: this.props.configuration,
          showCalcOptions: false
        }
      } else {
        this.state = {
          configuration: {},
          showCalcOptions: false
        }
      }
    } else {
      if(typeof exam !== 'undefined' && exam.sid && !customConfiguration) {
        this.state = {
          configuration: exam.configuration,
          showCalcOptions: false
        }
      } else if(customConfiguration) {
        this.state = {
          configuration: customConfiguration,
          showCalcOptions: false
        }
      } else {
        this.state = {
          configuration: exam.configuration,
          showCalcOptions: false
        }
      }
    }
  }

  onChange = (key, e) => {
    const { exam } = this.props
    const virtualCalcBox = document.querySelector('#permittedCalculator')

    if (key === 'permittedCalculator') { // This will only get triggered when checking the calculator checkbox
      this.setState({
        showCalcOptions: virtualCalcBox.checked
      });

      delete exam.configuration.virtualCalculatorType
    }

    this.props.handleInput(key, e, true, null, null, true); // This is currently in the onChange attribute and will need to stay
  }

  renderVirtualCalcOpts = key => {
    const { translation } = this.props;

    return (
      <div className="switch-notes" hidden={!this.state.configuration[key]}>
        {this.state.configuration[key] &&
          <div>
          <label htmlFor="virtual-calc">
            {translation.virtualCalc}
          </label>

          <label className="select">
            <select name="virtual-calc"
              id="virtual-calc"
              onChange={e => this.props.handleInput('virtualCalculatorType', e, true)}
              defaultValue={this.state.configuration.virtualCalculatorType}
              >
                <option value="">{translation.noVirtualCalc}</option>
                <option value="scientific-calc">{translation.scientificCalc}</option>
                <option value="graphing-calc">{translation.graphingCalc}</option>
                <option value="matrix-calc">{translation.matrixCalc}</option>
                <option value="four-function-calc">{translation.fourFunctionCalc}</option>
            </select>
          </label>
        </div>
        }
      </div>
    )
  }

  render() {
    const { translation } = this.props;

    let enabledItems = false;
    let hiddenItems = toJS(this.props.store.SettingsStore.settings.hidePermittedItemFields);

    // Loop through hidden items and edit them to match the permitted items formatting
    hiddenItems.forEach((item, i) => {
      const formattedItem = 'permitted' + item;
      hiddenItems[i] = formattedItem.toLowerCase();
    });

    return(
      <fieldset id="permitted-items" className="fields">
        <ul className="switch-list">
          {Object
            .keys(translation.options)
            .map(
              (key) => {
                // Return the input if this item is not in the hidden items array
                if(hiddenItems.indexOf(key.toLowerCase()) < 0) {
                  enabledItems = true;

                  return (
                    <li key={key} className={this.props.defaultDiff(`${key}Information`)}>
                      <label htmlFor={key}>{translation.options[key]}</label>

                      <input
                        type="checkbox"
                        id={key}
                        className="switch-input"
                        defaultChecked={this.state.configuration[key]}
                        onChange={(e) => this.onChange(key, e)}
                        disabled={this.props.readonly ? true : false}
                        onKeyDown={handleSwitchInputKeys}
                      />

                      <label className="switch-label" htmlFor={key}><span className="meta">{translation.options[key]}</span></label>

                      {this.props.renderDefault(`configuration.${key}`, null, true, translation.options[key])}

                      <LimitTextarea
                        id={`${key}-notes`}
                        wrapperClass="switch-notes"
                        className="textarea-grow"
                        placeholder={translation.additional_information}
                        defaultValue={this.state.configuration[`${key}Information`]}
                        onChange={(e) => {this.props.handleInput(`${key}Information`, e, true)}}
                        limit={255}
                        disabled={this.props.readonly ? true : false}
                      ></LimitTextarea>

                      {key === 'permittedCalculator' &&
                      this.props.virtualCalcAllowed &&
                        <FeatureFlag
                          flagKey='classcalc'
                          renderFeatureCallback={()=>this.renderVirtualCalcOpts(key)}
                        />
                      }

                      {key !== 'permittedCalculator' &&
                        <span className="switch-notes-default">{this.props.renderDefault(`configuration.${key}Information`)}</span>
                      }

                      {key === 'permittedCalculator' &&
                        <span className="switch-notes-default">{this.props.renderDefault('configuration.virtualCalculatorType')}</span>
                      }
                    </li>
                  )
                }

                return null;
              }
            )
          }
        </ul>

        {/* Show the other items field if it’s not in the hidden items array */}
        {hiddenItems.indexOf('permittedotherinformation') < 0 &&
          <ul className="fields">
            <li>
              <label className="lbl-optional" htmlFor="other-items">{translation.permittedOtherItems}</label>

              <textarea
                id="other-items"
                placeholder={translation.permittedOtherItems}
                defaultValue={this.state.configuration.permittedOtherItems}
                onChange={(e) => {this.props.handleInput('permittedOtherItems', e, true)}}
                disabled={this.props.readonly ? true : false}
              ></textarea>

              {enabledItems = true}
            </li>
          </ul>
        }

        {!enabledItems &&
          <span className="no-results">{translation.no_items}</span>
        }
      </fieldset>
    );
  }
})

export default translate('EditPermittedItems')(EditPermittedItems);



// WEBPACK FOOTER //
// ./src/app/components/ExamEdit/EditPermittedItems.js